<template>
  <div>
    <!-- light-row
    @row-select="x=>$emit('change', x)"-->
    <list
      row-key="Id"
      ref="list"
      unit="客户对账单"
      :page="page"
      :query-params="params"
      :show-checkbox="false"
      :show-query="showQuery"
      :get-data-func="getDataFunc"
      :show-summary="summaryShow"
      :summary-method="summaryFunc"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="客户名称">
          <!-- <select-input
            placeholder="请选择客户"
            :label="params.TradeUnitName"
            v-model="params.TradeUnitId"
            @click="openTradeunit"
          /> -->
          <customer  @restaurants='setSupplier' :state='params.TradeUnitName'/>
        </el-form-item>
        <!-- <el-form-item label="销售订单号">
          <el-input size="mini" clearable v-model="params.DocNo" placeholder="请填写销售订单号" />
        </el-form-item> -->
        <el-form-item label="对账周期">
          <el-select size="mini" v-model="params.Cycle" @change="cycleChange">
            <el-option value="今天"></el-option>
            <el-option value="昨天"></el-option>
            <el-option value="近3天"></el-option>
            <el-option value="近7天"></el-option>
            <el-option value="近14天"></el-option>
            <el-option value="本周"></el-option>
            <el-option value="上周"></el-option>
            <el-option value="本月"></el-option>
            <el-option value="上月"></el-option>
            <el-option value="本季"></el-option>
            <el-option value="上季"></el-option>
            <el-option value="本年"></el-option>
            <el-option value="上年"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="对账日期" v-if="!isMB">
          <range-picker
            :date="[params.DocDateStart, params.DocDateEnd]"
            @change="x=>{params.DocDateStart=x.Start;params.DocDateEnd=x.End;}"
          />
        </el-form-item>
        <el-form-item label="对账日期" v-if="isMB">
          <el-date-picker
            v-model.trim="params.DocDateStart"
            type="date"
            value-format="yyyy-MM-dd"
            style="width: 178px"
            placeholder="选择开始时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="截止日期" v-if="isMB">
          <el-date-picker
            v-model.trim="params.DocDateEnd"
            type="date"
            value-format="yyyy-MM-dd"
            style="width: 178px"
            placeholder="选择结束时间"
          ></el-date-picker>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="SrcVouTypeName" label="单据类型" min-width="110px" />
        <el-table-column prop="DocNo" label="单据编号" min-width="180px" show-overflow-tooltip />
        <el-table-column prop="BusinessTypeName" label="业务类型" />
        <el-table-column prop="DocDate" label="单据日期" min-width="100px">
          <template slot-scope="{row}">{{$commonJs.toDateString(row.DocDate)}}</template>
        </el-table-column>
        <el-table-column prop="DetailName" label="明细" />
        <!-- <el-table-column prop label="计量单位" /> -->
        <!-- <el-table-column prop label="数量" /> -->
        <!-- <el-table-column prop label="含税单价" /> -->
        <el-table-column prop="NeedAmount" label="应收" />
        <el-table-column prop="AlreadyAmount" label="已收" />
        <!-- <el-table-column prop="" label="应收转让" /> -->
        <!-- <el-table-column prop label="应付" /> -->
        <!-- <el-table-column prop label="已付" /> -->
        <!-- <el-table-column prop="" label="应付转让" /> -->
        <el-table-column prop="TradeUnitName" label="客户名称" min-width="130px" show-overflow-tooltip />
        <el-table-column prop="LeftAmount" label="余额" />
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
    <!-- <customer ref="customer" selectable @select="setTradeunit" /> -->
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
// import customer from "@/components/basicinfo/basic/logistics/listDialog";
import customer from "@/components/common/customer/customer";
export default {
  mixins: [listMixin],
  components: { list, customer },
  data() {
    return {
      api: require("@/api/fund/receipt").default,
      params: {
        DocNo: "",
        Cycle: "",
        BusinessTypes: null,
        TradeUnitId: null,
        TradeUnitName: "",
        TradeUnitTypes: [0, 2],
        DocDateStart: null,
        DocDateEnd: null,
      },
      isMB: this.$store.state.isMB,
      summaryShow: false,
      total: null
    };
  },
  methods: {
    setSupplier(data) {
      
      this.params.TradeUnitId = data.TradeUnitId;
      this.params.TradeUnitName = data.TradeUnitName;
    },
    openTradeunit() {
      this.$refs.customer.open().then((that) => {
        that.getData();
      });
    },
    setTradeunit(data) {
      this.params.TradeUnitId = data.Id;
      this.params.TradeUnitName = data.Name;
    },
    cycleChange(t) {
      var today = this.$commonJs.getToday();
      var start = "";
      var end = "";
      switch (t) {
        case "今天":
          start = today;
          end = today;
          break;
        case "昨天":
          start = this.$dayjs().subtract(1, "day").format("YYYY-MM-DD");
          end = start;
          break;
        case "近3天":
          start = this.$dayjs().subtract(2, "day").format("YYYY-MM-DD");
          end = today;
          break;
        case "近7天":
          start = this.$dayjs().subtract(6, "day").format("YYYY-MM-DD");
          end = today;
          break;
        case "近14天":
          start = this.$dayjs().subtract(13, "day").format("YYYY-MM-DD");
          end = today;
          break;
        case "本周":
          start = this.$dayjs().startOf("week").format("YYYY-MM-DD");
          end = today;
          break;
        case "上周":
          var week = this.$dayjs().subtract(1, "week");
          start = week.startOf("week").format("YYYY-MM-DD");
          end = week.endOf("week").format("YYYY-MM-DD");
          break;
        case "本月":
          start = this.$dayjs().startOf("month").format("YYYY-MM-DD");
          end = today;
          break;
        case "上月":
          var month = this.$dayjs().subtract(1, "month");
          start = month.startOf("month").format("YYYY-MM-DD");
          end = month.endOf("month").format("YYYY-MM-DD");
          break;
        case "本季":
          start = this.$dayjs().startOf("quarter").format("YYYY-MM-DD");
          end = today;
          break;
        case "上季":
          var quarter = this.$dayjs().subtract(1, "quarter");
          start = quarter.startOf("quarter").format("YYYY-MM-DD");
          end = quarter.endOf("quarter").format("YYYY-MM-DD");
          break;
        case "本年":
          start = this.$dayjs().startOf("year").format("YYYY-MM-DD");
          end = today;
          break;
        case "上年":
          var year = this.$dayjs().subtract(1, "year");
          start = year.startOf("year").format("YYYY-MM-DD");
          end = year.endOf("year").format("YYYY-MM-DD");
          break;
      }
      this.params.DocDateStart = start;
      this.params.DocDateEnd = end;
      this.query();
    },
    onExport() {
      var loading = this.$loading({
        lock: true,
        text: "正在导出...",
        spinner: "el-icon-loading",
        customClass: "my_loading",
        background: "rgba(0, 0, 0, 0.3)",
      });
      this.api.export(this.params).then(() => {
        loading.close();
      });
    },
    getDataFunc(params) {
      return new Promise((resolve, reject) => {
        this.api.getListChkRcv(params).then(res => {
          let times = Math.ceil(res.Count / params.pageSize);
          //判断是否最后一页
          if (times == params.pageIndex) {
            this.api.getListChkRcvTotal(params).then(res => {
              if (res.Code == 0 && res.Data) {
                this.total = res.Data[0];
                this.summaryShow = true;
              } else {
                this.summaryShow = false;
              }
            })
          } else {
            this.summaryShow = false;
          }
          resolve(res);
        })
      })
    },
    summaryFunc(param) {
      const { columns, data } = param;
      var fields = ['NeedAmount','AlreadyAmount']; //需要合计的字段
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        var field = fields.find(x => x == column.property);
        if (field) {
          console.log(field, index);
          sums[index] = "";
          if (this.total) {
            sums[index] = this.total[field].toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
          }
        } else {
          sums[index] = "";
        }
      });
      return sums;
    },
  },
};
</script>